import { render } from "./DialogSuccessGift.vue?vue&type=template&id=354eb0fa&scoped=true&ts=true"
import script from "./DialogSuccessGift.vue?vue&type=script&lang=ts"
export * from "./DialogSuccessGift.vue?vue&type=script&lang=ts"

import "./DialogSuccessGift.vue?vue&type=style&index=0&id=354eb0fa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mahmoud\\Desktop\\Bugs\\Dubai Projects\\JC_2\\mongo-web\\website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354eb0fa"]])

export default __exports__